module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/24.5986395b.png";